import React, { useEffect } from 'react';
import { Form, Input, InputNumber, Modal, Switch } from 'antd';
import { FaqItemAdmin, CreateFaqItemRequest } from '../../../types/faq.types';

interface FaqFormModalProps {
  open: boolean;
  loading: boolean;
  initialItem: FaqItemAdmin | null;
  onCancel: () => void;
  onSubmit: (values: CreateFaqItemRequest) => void;
}

export const FaqFormModal: React.FC<FaqFormModalProps> = ({
  open,
  loading,
  initialItem,
  onCancel,
  onSubmit,
}) => {
  const [form] = Form.useForm<CreateFaqItemRequest>();

  useEffect(() => {
    if (open) {
      if (initialItem) {
        form.setFieldsValue({
          question: initialItem.question,
          answer: initialItem.answer,
          displayOrder: initialItem.displayOrder,
          active: initialItem.active,
        });
      } else {
        form.resetFields();
        form.setFieldValue('active', true);
      }
    }
  }, [open, initialItem, form]);

  const handleOk = () => {
    form.validateFields().then(onSubmit);
  };

  return (
    <Modal
      title={initialItem ? 'Editar Pergunta Frequente' : 'Nova Pergunta Frequente'}
      open={open}
      onCancel={onCancel}
      onOk={handleOk}
      confirmLoading={loading}
      okText="Salvar"
      cancelText="Cancelar"
      width={640}
      destroyOnClose
    >
      <Form form={form} layout="vertical" style={{ marginTop: 16 }}>
        <Form.Item
          name="question"
          label="Pergunta"
          rules={[{ required: true, message: 'A pergunta é obrigatória' }]}
        >
          <Input.TextArea rows={3} maxLength={500} showCount placeholder="Digite a pergunta..." />
        </Form.Item>

        <Form.Item
          name="answer"
          label="Resposta"
          rules={[{ required: true, message: 'A resposta é obrigatória' }]}
        >
          <Input.TextArea rows={6} maxLength={5000} showCount placeholder="Digite a resposta..." />
        </Form.Item>

        <Form.Item
          name="displayOrder"
          label="Ordem de exibição"
          rules={[{ required: true, message: 'A ordem de exibição é obrigatória' }]}
        >
          <InputNumber min={1} style={{ width: '100%' }} placeholder="Ex: 1" />
        </Form.Item>

        <Form.Item name="active" label="Ativo" valuePropName="checked">
          <Switch />
        </Form.Item>
      </Form>
    </Modal>
  );
};
